import { Button, Flex, IconSaveLine, Spinner } from "@instructure/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { ExternalService } from "../../../../../services/ExternalService";
import { fileWriter } from "../../../../../utils/FileUtils";
import {
  ERROR,
  useNotification,
} from "../../../../CustomHooks/NotificationProvider";
import CustomRTE from "../../../../CustomTextArea/CustomRTE";

const Findings = ({ id, label, permission }) => {
  const showNotification = useNotification();
  const [findings, setFindings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    ExternalService.getFileContent("response.html", "findings", id)
      .then((res) => {
        if (res.content === "" && !permission) {
          setFindings("<p><em>No findings have been submitted yet.</em></p>");
        } else {
          setFindings(res.content);
        }
      })
      .catch(() =>
        showNotification(
          t("notifications.assessmentResults.getFindingError"),
          ERROR
        )
      );
  }, [id, permission, showNotification]);

  const handleSaveFindings = async (id, content) => {
    setSaving(true);
    try {
      const finding = fileWriter(content, "response.html", "text/html");
      await ExternalService.saveFile(finding, "findings", id);
      showNotification(t("notifications.assessmentResults.addFindingSuccess"));
    } catch {
      showNotification(
        t("notifications.assessmentResults.addFindingError"),
        ERROR
      );
    } finally {
      setSaving(false);
    }
  };

  return findings !== null ? (
    <Flex wrap="wrap">
      <Flex.Item size="100%">
        <CustomRTE
          id={id}
          label={label}
          defaultValue={findings}
          onChange={(value) => setFindings(value)}
          readOnly={!permission}
        />
      </Flex.Item>
      {permission && (
        <Flex.Item shouldGrow textAlign="end">
          <Button
            margin="small 0 0 0"
            color="primary"
            size="small"
            onClick={() => handleSaveFindings(id, findings)}
            disabled={saving}
            renderIcon={
              saving ? (
                <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
              ) : (
                IconSaveLine
              )
            }
          >
            {t("results.saveFindings")}
          </Button>
        </Flex.Item>
      )}
    </Flex>
  ) : (
    <Skeleton height="10rem" />
  );
};

export default Findings;
